// consent/initialiseConsent.ts

import { updateUserConsent } from './consentManager';
import { CONSENT_UPDATE_EVENT } from '../events/consentUpdateEvent';

/**
 * Initializes the consent system by setting up event listeners or other required initializations.
 */
export function initialiseConsentSystem(): void {
	document.addEventListener(CONSENT_UPDATE_EVENT, (event) => {
		if (event.detail) {
			// Update user consent using the extracted detail from the custom event
			updateUserConsent(event.detail.consentUpdates);
		}
	});
}
